import { render, staticRenderFns } from "./PatientUserStatusButton.vue?vue&type=template&id=3655cfd2"
import script from "./PatientUserStatusButton.vue?vue&type=script&lang=js"
export * from "./PatientUserStatusButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports